import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=bad08d04&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=bad08d04&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad08d04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad08d04')) {
      api.createRecord('bad08d04', component.options)
    } else {
      api.reload('bad08d04', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=bad08d04&scoped=true&", function () {
      api.rerender('bad08d04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4p7CN6WJbHERt/JS/comp/Paginate.vue"
export default component.exports